<template>
  <div>
    <search-bar :backgroundColorGray="true"></search-bar>

    <div class="products-table">
      <div class="container">
        <div class="product-details">
          <h1 class="ident">{{part.code}}</h1>
          <h3>{{part.part_subcategory_name}}</h3>

          <div class="row justify-content-md-center">
            <carousel :data="partImages"></carousel>
            </div>

          <h4 class="mt-5">Especificações</h4>
          <div class="prod-info">
            <table class="products">
              <tr>
                <th>Código de barras</th>
                <th v-if="checkExistence(dimensions.height)">Altura (mm)</th>
                <th v-if="checkExistence(dimensions.width)">Largura (mm)</th>
                <th v-if="checkExistence(dimensions.internal_diam)">Diâmetro Interno (mm)</th>
                <th v-if="checkExistence(dimensions.external_diam)">Diâmetro Externo (mm)</th>
                <th v-if="checkExistence(dimensions.screw_in)">Rosca Interna (mm)</th>
                <th v-if="checkExistence(dimensions.screw_out)">Rosca Externa (mm)</th>
                <th v-if="checkExistence(dimensions.beak_in)">Bico Interno (mm)</th>
                <th v-if="checkExistence(dimensions.beak_out)">Bico Externo (mm)</th>
                <th v-if="checkExistence(dimensions.length)">Comprimento (mm)</th>
                <th v-if="checkExistence(dimensions.weight)">Peso (kg)</th>
              </tr>
              <tr>
                <td>{{part.bar_code}}</td>
                <td v-if="checkExistence(dimensions.height)">{{dimensions.height}}</td>
                <td v-if="checkExistence(dimensions.width)">{{dimensions.width}}</td>
                <td v-if="checkExistence(dimensions.internal_diam)">{{dimensions.internal_diam}}</td>
                <td v-if="checkExistence(dimensions.external_diam)">{{dimensions.external_diam}}</td>
                <td v-if="checkExistence(dimensions.screw_in)">{{dimensions.screw_in}}</td>
                <td v-if="checkExistence(dimensions.screw_out)">{{dimensions.screw_out}}</td>
                <td v-if="checkExistence(dimensions.beak_in)">{{dimensions.beak_in}}</td>
                <td v-if="checkExistence(dimensions.beak_out)">{{dimensions.beak_out}}</td>
                <td v-if="checkExistence(dimensions.length)">{{dimensions.length}}</td>
                <td v-if="checkExistence(dimensions.weight)">{{dimensions.weight}}</td>
              </tr>
            </table>
            <table class="products" v-if="checkExistence(part.description)" style="margin-top: 20px;">
              <tr>
                <th>Observações</th>
              </tr>
              <tr>
                <td>{{part.description}}</td>
              </tr>
            </table>
          </div>

          <div class="mt-5 row">
            <div class="col-md-6">
              <h4>Equivalências</h4>
              <div class="prod-info d-flex flex-column align-items-center">
                <table class="products">
                  <tr>
                    <th>Fabricante</th>
                    <th>Código</th>
                  </tr>
                  <tr v-for="(equivalence, index) in shownEquivalences">
                    <td>{{equivalence.name}}</td>
                    <td>{{equivalence.equivalence_code}}</td>
                  </tr>
                </table>
                <button
                  type="button"
                  class="m-3 btn btn-primary"
                  v-if="equivalences.length > 4 && shownEquivalences.length !== equivalences.length"
                  @click="showMoreEquivs()"
                >Ver mais</button>
              </div>
            </div>
            <div class="col-md-6">
              <h4>Números Originais</h4>
              <div class="prod-info d-flex flex-column align-items-center">
                <table class="products">
                  <tr>
                    <th>Fabricante</th>
                    <th>Código</th>
                  </tr>
                  <tr v-for="original in originals">
                    <td>{{original.name}}</td>
                    <td>{{original.equivalence_code}}</td>
                  </tr>
                </table>
                <button
                  type="button"
                  class="m-3 btn btn-primary"
                  v-if="originals.length > 4 && shownOriginals.length !== originals.length"
                  @click="showMoreOriginals()"
                >Ver mais</button>
              </div>
            </div>
          </div>

          <h4 class="mt-5">Aplicações</h4>
          <div class="prod-info prod-info-collapse">
            <table class="products">
              <thead>
                <th>Fabricante</th>
                <th>Veículo</th>
                <th>Versão</th>
                <th>Ano</th>
                <th>Motor</th>
                <th>Ar</th>
                <th>Óleo</th>
                <th>Combustível</th>
                <th>Cabine</th>
                <th>Câmbio</th>
              </thead>
              <tbody v-for="(manufacturer, index) in vehicles">
                <tr>
                  <td
                    colspan="11"
                    data-toggle="collapse"
                    :data-target="`#manuf${index}`"
                    class="accordion-toggle collapsed"
                  >
                    <span>{{manufacturer.manufacturer}}</span>
                  </td>
                </tr>
                <tr class="accordian-body collapse" :id="`manuf${index}`">
                  <td colspan="11">
                    <tr v-for="vehicle in manufacturer.vehicles">
                      <td class="img">
                        <img :src="vehicle.thumb ? (url + vehicle.thumb) : '../../static/images/prod3.png'" alt>
                        <span>
                          <img :src="vehicle.thumb ? (url + vehicle.thumb) : '../../static/images/prod3.png'" alt>
                        </span>
                      </td>
                      <td>
                        <router-link :to="'/carro/' + vehicle.id">{{vehicle.model}}</router-link>
                      </td>
                      <td>{{vehicle.version}}</td>
                      <td>{{vehicle.year_from}} - {{vehicle.year_to}}</td>
                      <td>{{vehicle.engine}}</td>
                      <td>
                        <div
                          v-for="part in vehicle.vehicleParts"
                          :key="`part-${part.parts.id}`"
                        >
                          <div
                            class="d-flex align-items-center"
                            v-if="part.parts && part.parts.part_subcategory_id == 1"
                          >
                            <router-link
                              class="w-auto h-auto p-0 min-w-auto img"
                              :class="{'mr-2': part.details}"
                              target="_blank"
                              :to="'/produto/' + part.parts.code"

                            >{{part.parts.code}}&#10;
                              <span class="pointer">
                                <img :src="url + part.parts.img" alt>
                              </span>
                            </router-link>
                            <tooltip v-if="part.details">
                              {{ part.details }}
                            </tooltip>
                          </div>
                        </div>
                      </td>
                      <td>
                       <div
                          v-for="part in vehicle.vehicleParts"
                          :key="`part-${part.parts.id}`"
                        >
                          <div
                            class="d-flex align-items-center"
                            v-if="part.parts && part.parts.part_subcategory_id == 3"
                          >
                            <router-link
                              class="w-auto h-auto p-0 min-w-auto img"
                              :class="{'mr-2': part.details}"
                              target="_blank"
                              :to="'/produto/' + part.parts.code"

                            >{{part.parts.code}}&#10;
                              <span class="pointer">
                                <img :src="url + part.parts.img" alt>
                              </span>
                            </router-link>
                            <tooltip v-if="part.details">
                              {{ part.details }}
                            </tooltip>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          v-for="part in vehicle.vehicleParts"
                          :key="`part-${part.parts.id}`"
                        >
                          <div
                            class="d-flex align-items-center"
                            v-if="part.parts && part.parts.part_subcategory_id == 4"
                          >
                            <router-link
                              class="w-auto h-auto p-0 min-w-auto img"
                              :class="{'mr-2': part.details}"
                              target="_blank"
                              :to="'/produto/' + part.parts.code"

                            >{{part.parts.code}}&#10;
                              <span class="pointer">
                                <img :src="url + part.parts.img" alt>
                              </span>
                            </router-link>
                            <tooltip v-if="part.details">
                              {{ part.details }}
                            </tooltip>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          v-for="part in vehicle.vehicleParts"
                          :key="`part-${part.parts.id}`"
                        >
                          <div
                            class="d-flex align-items-center"
                            v-if="part.parts && part.parts.part_subcategory_id == 2"
                          >
                            <router-link
                              class="w-auto h-auto p-0 min-w-auto img"
                              :class="{'mr-2': part.details}"
                              target="_blank"
                              :to="'/produto/' + part.parts.code"

                            >{{part.parts.code}}&#10;
                              <span class="pointer">
                                <img :src="url + part.parts.img" alt>
                              </span>
                            </router-link>
                            <tooltip v-if="part.details">
                              {{ part.details }}
                            </tooltip>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          v-for="part in vehicle.vehicleParts"
                          :key="`part-${part.parts.id}`"
                        >
                          <div
                            class="d-flex align-items-center"
                            v-if="part.parts && part.parts.part_subcategory_id == 17"
                          >
                            <router-link
                              class="w-auto h-auto p-0 min-w-auto img"
                              :class="{'mr-2': part.details}"
                              target="_blank"
                              :to="'/produto/' + part.parts.code"

                            >{{part.parts.code}}&#10;
                              <span class="pointer">
                                <img :src="url + part.parts.img" alt>
                              </span>
                            </router-link>
                            <tooltip v-if="part.details">
                              {{ part.details }}
                            </tooltip>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="diagonal-line"></div>
  </div>
</template>
<script>
import VehicleAPI from "@/api/vehicle.vue";
import PartAPI from "@/api/part.vue";

import SearchBar from "@/components/SearchBar.vue";
import Tooltip from "@/components/Tooltip.vue";
import { isoToMmYyyy, isoToFullYear } from "@/utils/date.js";

// part_subcategory_id 1 == ar

export default {
  name: "Part",
  components: { SearchBar, Tooltip },
  data() {
    return {
      part: {},
      dimensions: {},
      vehicles: [],
      equivalences: [],
      shownEquivalences: [],
      groupedVehicles: [],
      originals: [],
      shownOriginals: [],
      partImages: [],
      url: "https://static.japanparts.com.br"
    };
  },
  async mounted() {
    await this.loadPart();
    this.loadDimensions();
    this.loadVehicles();
    this.loadEquivalences();
    this.loadImages();
  },
  watch: {
    async "$route.params.code"() {
      this.part = {};
      this.dimensions = {};
      this.vehicles = [];
      this.equivalences = [];
      this.shownEquivalences = [];
      this.groupedVehicles = [];
      this.originals = [];
      this.shownOriginals = [];
      this.partImages = [];

      await this.loadPart();
      this.loadDimensions();
      this.loadVehicles();
      this.loadEquivalences();
      this.loadImages();
    }
  },
  methods: {
    checkExistence(property) {
      return property && property != 0 && property !== "";
    },
    async loadPart() {
      const resp = await PartAPI.getByCode(this.$route.params.code);
      this.part = resp[0];
    },
    async loadDimensions() {
      const resp = await PartAPI.getDimensions(this.part.id);
      this.dimensions = resp[0] || [];
    },
    async loadVehicles() {
      const response = await PartAPI.getVehicles(this.part.id);
      response.data.forEach(vehicle => {
        const filteredParts = vehicle.vehicleParts.filter(partRelation => !!partRelation.parts);
        vehicle.vehicleParts = filteredParts;
      })
      this.groupByManufacturer(response.data);
    },
    async loadImages() {
      const resp = await PartAPI.getImages(this.part.id);
      this.partImages = resp;
      this.partImages.unshift({ thumb: this.part.img });
      this.partImages.forEach(img => {
        img.content = (createElement, content) =>
          createElement("img", {
            attrs: {
              src: this.url + img.thumb
            },
            class: "part-img"
          });
      });
    },
    groupByManufacturer(dataVehicles) {
      let manufacturerNames = new Set();

      dataVehicles.forEach(vehicle => {
        vehicle.year_from = this.formatVehicleYear(vehicle.year_from, "<--");
        vehicle.year_to = this.formatVehicleYear(vehicle.year_to, "-->");

        if (vehicle.vehicleManufacturers) {
          manufacturerNames.add(vehicle.vehicleManufacturers.name);
        }
      });

      manufacturerNames = Array.from(manufacturerNames);

      manufacturerNames.forEach(name => {
        let vehicles = dataVehicles.filter(vehicle => {
          return (
            vehicle.vehicleManufacturers &&
            vehicle.vehicleManufacturers.name === name
          );
        });
        this.vehicles.push({ manufacturer: name, vehicles });
      });
    },
    async loadEquivalences() {
      const resp = await PartAPI.getEquivalences(this.part.id);
      this.equivalences = resp.filter(vehicle => {
        return vehicle.original == 0;
      });
      this.originals = resp.filter(vehicle => {
        return vehicle.original == 1;
      });
      this.shownEquivalences = this.equivalences.slice(0, 4);
    },
    showMoreEquivs() {
      this.shownEquivalences = this.equivalences.slice(
        0,
        this.shownEquivalences.length + 4
      );
    },
    showMoreOriginals() {
      this.shownOriginals = this.originals.slice(
        0,
        this.shownOriginals.length + 4
      );
    },
    formatVehicleYear(date, nullReplacer) {
      if (date) {
        const month = new Date(date).getUTCMonth() + 1;

        if (month === 1) {
          return isoToFullYear(date, nullReplacer);
        }
      }

      return isoToMmYyyy(date, nullReplacer);
    }
  }
};
</script>
<style>
div.products-table .carousel__item {
  width: 100%;
  height: 320px !important;
}

/* Centraliza as fotos */
div.products-table ul {
  text-align: center;
}
.part-img {
  height: 100%;
  object-fit: contain; /* Restringe a proporção original das fotos */
  max-width: 400px;
}

.btn-load {
  color: white !important;
}

a {
  cursor: pointer;
}
a:not([href]):not([tabindex]) {
  color: #ccb025;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: #0056b3;
}

.prod-info-collapse td {
  width: 118px;
}

@media print {
  header:first-of-type,
  footer,
  .global-search,
  .copy {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Part.vue